import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  checkValidations,
  requiredRule
} from 'src/util/validation/commonValidation.helpers'

import CodeNotExist from '../../components/popups/reward/CodeNotExist'
import Reward from '../../components/reward/Reward'
import {
  DEFAULT_CONTAINER_STATE,
  REWARD_POINTS_PROCESS_STEP
} from '../../constants/containerStates'
import { SIGNUP_URL } from '../../constants/navigation'
import { REWARDS_PROFILE_DISPATCH } from '../../store/reducers/rewards/rewards'
import { containsNoValues } from '../../util/object.helpers'
import { validRewardCodeRule } from '../../util/validation/validation.helpers'

const RewardContainer = ({
  rewardsProfile,
  changeRewardsState,
  changeRewardsInputAndErrorState,
  qrCodeEnabled,
  onQrCodeClick
}) => {
  const { t } = useTranslation()
  const [popupState, setPopupState] = useState(DEFAULT_CONTAINER_STATE.NONE)
  const navigate = useNavigate()

  useEffect(() => {
    return () => {
      changeRewardsState(REWARDS_PROFILE_DISPATCH.ERROR, {})
    }
  }, [])

  const onFormSubmit = () => {
    changeRewardsState(REWARDS_PROFILE_DISPATCH.ERROR, {})
    const { rewardCode } = rewardsProfile
    const errors = checkValidations({
      rewardCode: { value: rewardCode, rules: [requiredRule] }
    })
    if (containsNoValues(errors)) {
      const validRewardCode = validRewardCodeRule(rewardCode)
      if (validRewardCode) {
        changeRewardsState(
          REWARDS_PROFILE_DISPATCH.REWARD_CODE,
          validRewardCode
        )
        navigate(SIGNUP_URL, { replace: true })
      } else {
        setPopupState(REWARD_POINTS_PROCESS_STEP.WRONG_REWARD_CODE)
      }
    } else {
      changeRewardsState(REWARDS_PROFILE_DISPATCH.ERROR, errors)
    }
  }

  const handleOnTryAgain = () => {
    changeRewardsState(REWARDS_PROFILE_DISPATCH.REWARD_CODE, '')
    setPopupState(DEFAULT_CONTAINER_STATE.NONE)
  }

  const renderPopup = () => {
    switch (popupState) {
      case REWARD_POINTS_PROCESS_STEP.WRONG_REWARD_CODE:
        return <CodeNotExist onSubmit={handleOnTryAgain} t={t} />
      default:
        break
    }
  }

  return (
    <>
      <Reward
        rewardsProfile={rewardsProfile}
        onFormSubmit={onFormSubmit}
        dispatchAction={changeRewardsInputAndErrorState}
        t={t}
        onQrCodeClick={onQrCodeClick}
        qrCodeEnabled={qrCodeEnabled}
      />
      {renderPopup()}
    </>
  )
}

export default RewardContainer
